
export default {
  name: 'home',
  components: {

  },
  data() {
    return {
      list: [],
      navList: [],
      params: {
        pageNumber: 1,
        pageSize: 20,
        trade_type_id: '-1'
      },
      states: {},
      lastPage: false
    }
  },
  created() {
  },
  mounted: function () {
    this.getNavs()
  },
  methods: {
    changeTable: function(id) {
      this.list = []
      this.params.trade_type_id = id
      this.params.pageNumber = 1
      this.lastPage = false
      this.getList()
    },
    load() {
      setTimeout(d => {
        this.getList()
      }, 100)
    },
    toHb: function () {
      this.$message('正在开发')
    },
    toLinks: function () {
      this.$router.push({ path: '/links' })
    },
    toHome: function () {
      this.$router.push({ path: '/home' })
    },
    toMy: function () {
      this.$router.push({ path: '/my' })
    },
    toHome: function () {
      this.$router.push({ path: '/home' })
    },
    toBindAli: function () {
      this.$router.push({ path: '/bindAli' })
    },

    toList: function () {
      this.$router.push({ path: '/list' })
    },
    getNavs: function () {
      this.apiGet('/h5/api/user/account/logTypeList', '', res => {
        if (res.state) {
          this.navList = res.data
          this.navList.unshift({
            trade_type: '全部',
            id: '-1'
          })
          this.$forceUpdate()
          this.getList()
        } else {
          this.$message(res.msg)
        }
      })
    },
    backPage: function() {
      window.history.go(-1)
    },
    getList: function () {
      let params = JSON.stringify(this.params)
      params = JSON.parse(params)
      if (params.trade_type_id == -1) {
        params.trade_type_id = ''
      }
      if (this.lastPage) {
        return
      }
      this.apiGet('/h5/api/user/account/logList', params, res => {
        this.lastPage = true;
        if (res.state) {
          this.params.pageNumber++
          this.list = this.list.concat(res.data.list);
          setTimeout(d=>{
            this.lastPage = res.data.lastPage;
          },500)
          // this.lastPage = res.data.lastPage
        } else {
          // this.$message(res.msg);
        }
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/account-log/account-log.js